import { AccountBalance } from '@eika-kortbetjening/types';

import { BalanceType, CreditCardAccount } from '@generated-types';

const getBalance = (account: CreditCardAccount): AccountBalance => {
    const limit = account.creditLimit || 0;
    const balance = account.balances.find((b) => b.type === BalanceType.AVAILABLE)?.amount || 0;
    const saldo = account.balances.find((b) => b.type === BalanceType.EXPECTED)?.amount || 0;

    return {
        balance,
        limit,
        saldo,
    };
};

export const AccountService = {
    getBalance,
};
